const features = [
  {
    icon: "ri-flashlight-line",
    title: "초고속 발송",
    desc: "평균 0.3초 이내 발송 완료. 실시간 이벤트, 인증번호 발송에 최적화된 초고속 인프라를 제공합니다.",
    gradient: "from-violet-500 to-purple-600",
    glow: "bg-violet-500/10",
  },
  {
    icon: "ri-shield-check-line",
    title: "99.9% 발송 보장",
    desc: "SKT, KT, LGU+ 3사 통신망 동시 연동으로 어떤 상황에서도 안정적인 발송 성공률을 보장합니다.",
    gradient: "from-pink-500 to-rose-600",
    glow: "bg-pink-500/10",
  },
  {
    icon: "ri-bar-chart-box-line",
    title: "실시간 발송 통계",
    desc: "발송 현황, 성공/실패 내역, 수신 확인까지 대시보드에서 실시간으로 모니터링하세요.",
    gradient: "from-violet-400 to-pink-500",
    glow: "bg-violet-400/10",
  },
  {
    icon: "ri-calendar-schedule-line",
    title: "예약 발송",
    desc: "원하는 날짜와 시간에 자동 발송되도록 예약 설정. 마케팅 캠페인을 미리 준비하세요.",
    gradient: "from-fuchsia-500 to-violet-600",
    glow: "bg-fuchsia-500/10",
  },
  {
    icon: "ri-group-2-line",
    title: "대량 발송",
    desc: "수천 명에게 동시 발송도 문제없습니다. 엑셀 파일 업로드로 수신자 목록을 간편하게 관리하세요.",
    gradient: "from-pink-400 to-fuchsia-600",
    glow: "bg-pink-400/10",
  },
  {
    icon: "ri-code-s-slash-line",
    title: "API 연동",
    desc: "RESTful API로 기존 서비스에 손쉽게 통합. 다양한 언어의 SDK와 상세한 문서를 제공합니다.",
    gradient: "from-violet-500 to-indigo-500",
    glow: "bg-violet-500/10",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-[#0a0a18] py-24 px-6 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-violet-500/30 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-pink-500/20 to-transparent" />
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-pink-600/8 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-1/3 left-0 w-80 h-80 bg-violet-600/8 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-violet-400 text-xs font-semibold tracking-widest uppercase mb-3 block">
            FEATURES
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            왜{" "}
            <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent">
              Signal SMS
            </span>
            인가요?
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed">
            단순한 문자 발송을 넘어, 비즈니스 성장을 위한 완전한 메시지 솔루션을 제공합니다.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group relative bg-white/[0.03] border border-white/[0.08] rounded-2xl p-7 hover:border-white/20 hover:bg-white/[0.06] transition-all duration-300 hover:-translate-y-1 cursor-default"
            >
              {/* Glow on hover */}
              <div className={`absolute inset-0 rounded-2xl ${feature.glow} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />

              <div className="relative z-10">
                {/* Icon */}
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br ${feature.gradient} mb-5`}>
                  <i className={`${feature.icon} text-white text-xl`}></i>
                </div>

                {/* Text */}
                <h3 className="text-white font-bold text-lg mb-2.5">{feature.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom highlight bar */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[
            { value: "24/7", label: "고객 지원", icon: "ri-customer-service-2-line" },
            { value: "5분", label: "빠른 가입 & 시작", icon: "ri-rocket-2-line" },
            { value: "무약정", label: "자유로운 이용", icon: "ri-lock-unlock-line" },
          ].map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-4 bg-white/[0.03] border border-white/[0.08] rounded-xl px-6 py-5"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-gradient-to-br from-violet-500/30 to-pink-500/30 shrink-0">
                <i className={`${item.icon} text-violet-300 text-lg`}></i>
              </div>
              <div>
                <div className="text-white font-bold text-xl leading-tight">{item.value}</div>
                <div className="text-gray-400 text-sm">{item.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}